/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useState } from 'react';
import { DirectLine } from 'botframework-directlinejs';
import ReactWebChat, { createStore } from 'botframework-webchat';
import './ChatComponent.css';
import { getQueryParam } from './utils/getQueryParam';
import { getToken } from './utils/getToken';
import styled from 'styled-components';

const md = require('markdown-it')({ linkify: false });

/* istanbul ignore next */
function getUserId(): string {
    // TODO: need to update to get the identity from Magician app
    const myuserid = 'YOUR_USER_ID_' + Math.random().toString();
    return myuserid;
}

/* istanbul ignore next */
const store = createStore(
    {},
    ({ dispatch }: any) => (next: any) => (action: any) => {
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
            dispatch({
                type: 'WEB_CHAT/SEND_EVENT',
                payload: {
                    name: 'webchat/join',
                    value: {
                        magVersion: getQueryParam('version') ?? 0
                    }
                }
            });
        }
        return next(action);
    }
);

const ChatComponentWrapper = styled.div`
    html,
    ::-webkit-scrollbar {
        width: 12px;
        background: ${(props) => props.theme.scrollBackgroundColor};
    }

    ::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.scrollThumbColor};
        background-clip: padding-box;
        border: solid 4px transparent;
        border-radius: 1px;
    }
    
    .webchat__suggested-action__button {
        font-family: SamsungOneUILatin500 !important;
        font-size: 12px !important;
        padding: 5px 6px !important;
    }

    .webchat__suggested-action__button:hover {
        background: ${(props) => props.theme.suggestedBtnBackgroundColorHover}!important;
        border-color: ${(props) => props.theme.suggestedBtnBorderHover} !important;
        color: ${(props) => props.theme.suggestedBtnTextHover} !important;
    }

    .webchat__suggested-action__button:active {
        background: ${(props) => props.theme.suggestedBtnBackgroundColorActive}!important;
        border-color: ${(props) => props.theme.suggestedBtnBorderActive} !important;
        color: ${(props) => props.theme.suggestedBtnTextActive} !important;
    }

    .ac-pushButton.style-default {
        width: 200px;
        height: 36px;
        background-color: ${(props) => props.theme.acBtnBackgroundColor} !important;
        color: ${(props) => props.theme.acBtnTextColor} !important;
        border: none !important;
        font-family: samsungOneUILatin500 !important;
        font-size: 12px !important;
        font-weight: 100 !important;
        border-radius: 8px;
        padding: 12px 14px !important;
        justify-content: flex-start !important;
    }

    .ac-pushButton.style-default:hover {
        background: ${(props) => props.theme.acBtnGradientHover} !important;
    }

    .ac-pushButton.style-default:active {
        background: ${(props) => props.theme.acBtnGradientActive} !important;
    }
`;

// see: https://github.com/microsoft/BotFramework-WebChat/blob/main/packages/api/src/defaultStyleOptions.ts
// https://github.com/microsoft/BotFramework-WebChat/tree/main/samples/02.branding-styling-and-customization/b.idiosyncratic-manual-styles
const styleOptions = {
    dark: {
        backgroundColor: 'rgba(28, 28, 28, 1)',
        hideUploadButton: true,

        primaryFont: 'SamsungOneUILatin500',
        fontSizeSmall: '12px',

        // bubble from use
        bubbleFromUserNubOffset: 10,
        bubbleFromUserNubSize: 10,
        bubbleFromUserBorderWidth: 0,
        bubbleFromUserBorderRadius: 8,
        bubbleFromUserTextColor: 'rgba(255, 255, 255, 1)',
        bubbleFromUserBackground: 'rgba(32, 155, 255, 1)',

        // bubble from bot
        bubbleNubOffset: 10,
        bubbleNubSize: 10,
        bubbleBorderWidth: 0,
        bubbleBorderRadius: 8,
        bubbleTextColor: 'rgba(255, 255, 255, 1)',
        bubbleBackground: 'rgba(49, 49, 50, 0.6)',
        showAvatarInGroup: true,

        // suggested actions
        suggestedActionHeight: 24,
        suggestedActionBackground: 'rgba(38, 38, 38, 1)',
        suggestedActionBorderColor: 'rgba(62, 63, 67, 1)',
        suggestedActionBorderRadius: '4px',
        suggestedActionBorderWidth: 1,
        suggestedActionTextColor: 'rgba(174, 176, 184, 1)',

        // sendbox
        sendBoxBorderTop: 'solid 1px rgba(255, 255, 255, 0.1)',
        sendBoxBackground: 'rgba(28, 28, 28, 1)',
        sendBoxHeight: 68,
        sendBoxPlaceholderColor: 'rgba(124, 125, 129, 1)',
        sendBoxTextColor: 'rgba(255, 255, 255, 1)',

        // visual focus
        transcriptActivityVisualKeyboardIndicatorWidth: 0,
        transcriptVisualKeyboardIndicatorWidth: 0,

        // hide end of transcript
        hideScrollToEndButton: true,

        // Typing animation
        typingAnimationBackgroundImage: 'url(/img_Chatbot_loading.png)',
        typingAnimationDuration: 30000},
    light: {
        backgroundColor: '#F3F9FF',
        hideUploadButton: true,

        primaryFont: 'SamsungOneUILatin500',
        fontSizeSmall: '12px',

        // bubble from use
        bubbleFromUserNubOffset: 5,
        bubbleFromUserNubSize: 8,
        bubbleFromUserBorderWidth: 0,
        bubbleFromUserBorderRadius: 8,
        bubbleFromUserTextColor: '#182439',
        bubbleFromUserBackground: '#eaf1f9',

        // bubble from bot
        bubbleNubOffset: 5,
        bubbleNubSize: 8,
        bubbleBorderWidth: 0,
        bubbleBorderRadius: 8,
        bubbleTextColor: '#182439',
        bubbleBackground: '#dce9f3',
        showAvatarInGroup: true,

        // suggested actions
        suggestedActionWidth: 120,
        suggestedActionHeight: 26,
        suggestedActionBorderRadius: '26px',
        suggestedActionBorderWidth: 2,

        // sendbox
        sendBoxBorderTop: 'none',
        sendBoxTextColor: 'rgba(0, 0, 0, 0.7)',
        sendBoxBackground: '#dce9f3',
        sendBoxHeight: 40,
        sendBoxButtonColorOnHover: '#1FA8FF',

        // visual focus
        transcriptActivityVisualKeyboardIndicatorWidth: 0,
        transcriptVisualKeyboardIndicatorWidth: 0,

        // hide end of transcript
        hideScrollToEndButton: true,

        // Typing animation
        typingAnimationBackgroundImage: 'url(/img_Chatbot_loading.png)',
        typingAnimationDuration: 30000
    }
};

export default function ChatComponent(): JSX.Element {
    const [directLine, setDirectLine] = useState<DirectLine>();
    const [locale, setLocale] = useState<string>('en-US');
    const [myUserId, setMyUserId] = useState<string>();
    const [style, setStyle] = useState<any>();

    useEffect(() => {
        setMyUserId(getUserId());

        // for local dev: http://localhost:3000/?tokenURL=http://localhost:3978/directline/token
        const tokenURL = getQueryParam('tokenURL') ?? '/bot/directline/token';
        console.log('tokenURL=', tokenURL);

        // eslint-disable-next-line max-len
        // for local dev: http://localhost:3000/?tokenURL=http://localhost:3978/directline/token&directlineURL=http://localhost:1784/v3/directline
        const directlineURL = getQueryParam('directlineURL');
        console.log('directlineURL=', directlineURL);
        void getToken(tokenURL).then((token) => {
            if(token && directlineURL)
                setDirectLine(new DirectLine({ token, domain: String(directlineURL), webSocket: false }));
            else
                setDirectLine(new DirectLine({ token }));
        });

        const theme = getQueryParam('theme') ?? 'dark';
        setStyle(theme === 'light' ? styleOptions.light : styleOptions.dark);
    }, []);

    /* istanbul ignore next */
    const attachmentMiddleware = () => (next: any) => (card: any) => {
        switch (card.attachment.contentType) {
            default:
                return next(card);
        }
    };

    const cardActionMiddleware = () => (next: any) => (action: any) => {
        const { cardAction: { type, value } } = action;
        if (type === 'openUrl') {
            const path = 'imgs?url=' + String(value);
            window.open(path, '_blank');
        }
        else
        {
            return next(action);
        }
    };

    return (
        <ChatComponentWrapper>
            {   /* istanbul ignore next */
                directLine &&
                <div id="webchat_container">
                    {/* https://github.com/microsoft/BotFramework-WebChat/blob/main/docs/API.md */}
                    <ReactWebChat renderMarkdown={ md.render.bind(md) }
                        directLine={directLine}
                        locale={locale}
                        styleOptions={style}
                        username={myUserId}
                        store={store}
                        attachmentMiddleware={attachmentMiddleware}
                        cardActionMiddleware={cardActionMiddleware}
                    />
                </div>
            }
        </ChatComponentWrapper>
    );
}
